

            <!-- Basic Details -->
     
<div class="row 2">
            <div class="col-md-4">
              <label for="orderDate">Date of Supply</label>
              <input type="date" id="orderDate" name="orderDate" class="form-control"
                [(ngModel)]="ClinicSupply.dateOfOrder" />
            </div>
             <div class="col-md-4">
               <label >Clinic</label>
                              <select name="clinic" class="form-select" [(ngModel)]="ClinicSupply.ClinincName">
                                <option value="">Select Clinic</option>
                                <option value="">Clinic 1</option>
                                <option value="">Clinic 2</option>
                                <option value="">Clinic 3</option>
                              </select>
            </div>
</div>

           
            <!-- Product Table -->
            <div class="col-md-12 mt-4">
              <h5 class="mb-2">Products</h5>
              <table class="table table-bordered table-sm align-middle">
                <thead class="table-light">
                  <tr>
                    <th style="width: 37%">Item Name</th>
                    <th style="width: 12%">Quantity</th>
                    <th style="width: 18%">Unit Price</th>
                    <th style="width: 21%">Total Price</th>
                    <th style="width: 12%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of orderItems; let i = index">
                    <td>
                      <select class="form-control" [(ngModel)]="row.itemName"
                        [ngModelOptions]="{standalone: true}">
                        <option value="">Select Item</option>
                        <option *ngFor="let opt of itemOptions" [value]="opt.value">{{ opt.label }}</option>
                      </select>
                    </td>
                    <td>
                      <input type="number" class="form-control" [(ngModel)]="row.quantity"
                        (input)="calculateRowTotal(i)" [ngModelOptions]="{standalone: true}">
                    </td>
                    <td>
                      <input type="number" class="form-control" [(ngModel)]="row.unitPrice"
                        (input)="calculateRowTotal(i)" [ngModelOptions]="{standalone: true}">
                    </td>
                    <td>
                      <input type="number" class="form-control" [(ngModel)]="row.totalPrice" readonly
                        [ngModelOptions]="{standalone: true}">
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-sm btn-danger" (click)="removeRow(i)">
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-between">
                <button type="button" class="btn btn-outline-primary" (click)="addRow()">
                  <i class="pi pi-plus"></i> Add Row
                </button>
                <h5 class="mb-0">
                  Final Price:
                  <strong>{{ calculateFinalPrice() | number:'1.2-2' }}</strong>
                </h5>
              </div>
            </div>

            <!-- Delivery Status -->
            

         